// import createHistory from 'history/createBrowserHistory'; // gives warning
const createHistory = require('history').createBrowserHistory;

export default createHistory();
